<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="frontmatter Dedication"><p id="rw-p_127428-00001"><a id="pb-rw_v"></a></p><a id="pb-rw_v"> <br/><br/><br/><br/><br/><br/> <p id="rw-p_127428-00002" style="text-align: center;">For Trev Taylor</p> </a><p id="rw-p_127428-00003"><a id="pb-rw_v"></a><a id="pb-rw_vi"></a></p></div><a id="pb-rw_vi">
</a></div><a id="pb-rw_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// a9781847677099_dedication.vue?7b5388cd